// Social media handles - localStorage only
export interface SocialHandle {
  platform: string;
  handle: string;
  url: string;
  color: string;
  bgColor: string;
  placeholder: string;
  icon: string;
}

const STORE_KEY = 'uxcf_social_handles';

export const PLATFORM_DEFS: Omit<SocialHandle, 'handle'>[] = [
  { platform: 'LinkedIn', icon: 'in', color: '#fff', bgColor: '#0077B5', placeholder: 'linkedin.com/in/yourname', url: 'https://linkedin.com/in/' },
  { platform: 'Instagram', icon: '@', color: '#fff', bgColor: '#E1306C', placeholder: '@yourhandle', url: 'https://instagram.com/' },
  { platform: 'YouTube', icon: 'YT', color: '#fff', bgColor: '#FF0000', placeholder: '@yourchannel', url: 'https://youtube.com/@' },
  { platform: 'Facebook', icon: 'fb', color: '#fff', bgColor: '#1877F2', placeholder: 'facebook.com/yourpage', url: 'https://facebook.com/' },
  { platform: 'WhatsApp', icon: 'wa', color: '#fff', bgColor: '#25D366', placeholder: '+1234567890 (channel)', url: 'https://wa.me/' },
  { platform: 'TikTok', icon: 'tt', color: '#fff', bgColor: '#010101', placeholder: '@yourhandle', url: 'https://tiktok.com/@' },
  { platform: 'Twitter/X', icon: 'X', color: '#fff', bgColor: '#1DA1F2', placeholder: '@yourhandle', url: 'https://x.com/' },
];

export function getSocialHandles(): Record<string, string> {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

export function saveSocialHandle(platform: string, handle: string): void {
  const handles = getSocialHandles();
  handles[platform] = handle.trim();
  localStorage.setItem(STORE_KEY, JSON.stringify(handles));
}

export function clearSocialHandle(platform: string): void {
  const handles = getSocialHandles();
  delete handles[platform];
  localStorage.setItem(STORE_KEY, JSON.stringify(handles));
}
